export function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () =>
      reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}

export function isNotEmpty(value) {
  return value !== null && value !== undefined && value !== '';
}

export function isValidJson(value) {
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return false;
  }
}

export function safeParseJson(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

export function firstValidValue(...values) {
  for (const value of values) {
    let result = value === 0 || value
    // Check if the value is 0 or any other valid value (not null, undefined, or empty string)
    if (result) {
      return value;
    }
  }
  return null; // Return null if no valid values found
} 

export function scrollToElement(id, offset = 0) {
  const element = document.getElementById(id);
  if (element) {
    // Calculate the element's position relative to the document
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    const targetPosition = elementTop - offset;
    // Smoothly scroll to the calculated position
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  }
}
